import TipoServico from "./TipoServico";
import TipoMaterial from "./TipoMaterial";
import TipoMaterialPE from "./TipoMaterialPE";
import TipoViagem from "./TipoViagem";
import TipoRecurso from "./TipoRecurso";
import Alfabeto from "./Alfabeto";
import Funcao from "./Funcao";
import Segmento from "./Segmento";
import TipoEntregaveis from "./TipoEntregaveis";
import SubTipoEntregaveis from "./SubTipoEntregaveis";
import SubTipoCronogramaFinanceiro from "./SubTipoCronogramaFinanceiro";
import StatusEtapa from "./StatusEtapa";

import RegraProjeto from "./RegraProjeto";
import TipoCompartilhamentoResultados from "./TIpoCompartilhamentoResultados";

import OrigemDespesa from "./OrigemDespesa";
import TipoDocumentoProjeto from "./TipoDocumentoProjeto";

import TipoImpactoEconomico from "./TipoImpactoEconomico";
import TipoProducaoCientifica from "./TipoProducaoCientifica";
import TipoCapacitacaoProfissional from "./TipoCapacitacaoProfissional";
import TipoImpactoSocioambiental from "./TipoImpactoSocioambiental";
import TipoApoioInfraEstrutura from "./TipoApoioInfraEstrutura";
import TipoPropriedadeIntelectual from "./TipoPropriedadeIntelectual";

import PGServicoTerceiro from "./PGServicoTerceiro";
import PGMaterialConsumo from "./PGMaterialConsumo";
import PGViagemDiaria from "./PGViagemDiaria";
import PGOutros from "./PGOutros";
import PGAuditoria from "./PGAuditoria";
import PGCitenel from "./PGCitenel";

import StatusPropostaProjeto from "./StatusPropostaProjeto";
import StatusProjetoGestao from "./StatusProjetoGestao";

import TipoReceita from "./TipoReceita";
import TipoDeducoes from "./TipoDeducoes";
import Rubricas from "./Rubricas";
import TipoEmpresa from "./TipoEmpresa";
import Classificacao from "./Classificacao";
import FaseInovacao from "./FaseInovacao";
import TRL from "./TRL";

import UF from "./UF";
import Titulacao from "./Titulacao";
import Nacionalidade from "./Nacionalidade";

import OutrosEnum from "./OutrosEnum";
import TipoProduto from "./TipoProduto";
import Permissoes from "./Permissoes";

import TipoAlerta from "./TipoAlerta";

import Periodicidade from "./Periodicidade";
import ContratoLicenca from "./ContratoLicenca";

export default {
  getTipoServico(v) {
    if (v == -1) return { value: -1, text: "Total" };
    return TipoServico.find((el) => el.value == v);
  },

  getTipoServicos() {
    return TipoServico;
  },

  getTipoMaterial(v) {
    if (v == -1) return { value: -1, text: "Total" };
    return TipoMaterial.find((el) => el.value == v);
  },
  getTipoMateriais() {
    return TipoMaterial;
  },

  getTipoMaterialPE(v) {
    if (v == -1) return { value: -1, text: "Total" };
    return TipoMaterialPE.find((el) => el.value == v);
  },
  getTipoMateriaisPE() {
    return TipoMaterialPE;
  },

  getTipoViagem(v) {
    if (v == -1) return { value: -1, text: "Total" };
    return TipoViagem.find((el) => el.value == v);
  },
  getTipoViagens() {
    return TipoViagem;
  },

  getTipoRecurso(v) {
    if (v == -1) return { value: -1, text: "Total" };
    return TipoRecurso.find((el) => el.value == v);
  },
  getTipoRecursos() {
    return TipoRecurso;
  },

  getLetra(v) {
    if (v == -1) return { value: -1, text: "Total" };
    return Alfabeto.find((el) => el.value == v);
  },
  getAlfabeto() {
    return Alfabeto;
  },

  getFuncao(v) {
    if (v == -1) return { value: -1, text: "Total" };
    return Funcao.find((el) => el.value == v);
  },
  getFuncoes() {
    return Funcao;
  },

  getTipoEntregavel(v) {
    if (v == -1) return { value: -1, text: "Total" };
    return TipoEntregaveis.find((el) => el.value == v);
  },
  getTipoEntregaveis() {
    return TipoEntregaveis;
  },
  TipoEntregaveis,

  getSubTipoEntregavel(v) {
    if (!v) return { value: 0, text: "" };
    if (v == -1) return { value: -1, text: "Total" };
    return SubTipoEntregaveis.find((el) => el.value == v);
  },
  getSubTipoEntregaveis() {
    return SubTipoEntregaveis;
  },
  SubTipoEntregaveis,

  getSubTipoCronogramaFinanceiro(v) {
    if (v == -1) return { value: -1, text: "Total" };
    return SubTipoCronogramaFinanceiro.find((el) => el.value == v);
  },
  getSubTiposCronogramaFinanceiro() {
    return SubTipoCronogramaFinanceiro;
  },

  getStatusEtapa(v) {
    if (v == -1) return { value: -1, text: "Total" };
    return StatusEtapa.find((el) => el.value == v);
  },
  getStatusEtapas() {
    return StatusEtapa;
  },

  getSegmento(v) {
    return Segmento.find((el) => el.value == v);
  },
  getSegmentos() {
    return Segmento;
  },

  getRegraProjetos(v) {
    return RegraProjeto.find((el) => el.value == v);
  },
  getRegrasProjetos() {
    return RegraProjeto;
  },

  getTipoCompatilhamentoResultados(v) {
    return TipoCompartilhamentoResultados.find((el) => el.value == v);
  },
  getTiposCompatilhamentosResultados() {
    return TipoCompartilhamentoResultados;
  },

  getOrigemDespesa(v) {
    return OrigemDespesa.find((el) => el.value == v);
  },
  getOrigensDepesas() {
    return OrigemDespesa;
  },

  getTipoDocumentoProjeto(v) {
    return TipoDocumentoProjeto.find((el) => el.value == v);
  },
  getTiposDocumentoProjeto() {
    return TipoDocumentoProjeto;
  },

  getTipoImpactoEconomico(v) {
    return TipoImpactoEconomico.find((el) => el.value == v);
  },
  getTiposImpactoEconomico() {
    return TipoImpactoEconomico;
  },

  getTipoProducaoCientifica(v) {
    return TipoProducaoCientifica.find((el) => el.value == v);
  },
  getTiposProducaoCientifica() {
    return TipoProducaoCientifica;
  },

  getTipoCapacitacaoProfissional(v) {
    return TipoCapacitacaoProfissional.find((el) => el.value == v);
  },
  getTiposCapacitacaoProfissional() {
    return TipoCapacitacaoProfissional;
  },

  getTipoImpactoSocioambiental(v) {
    return TipoImpactoSocioambiental.find((el) => el.value == v);
  },
  getTiposImpactoSocioambiental() {
    return TipoImpactoSocioambiental;
  },

  getTipoApoioInfraEstrutura(v) {
    return TipoApoioInfraEstrutura.find((el) => el.value == v);
  },
  getTiposApoioInfraEstrutura() {
    return TipoApoioInfraEstrutura;
  },

  getTipoPropriedadeIntelectual(v) {
    return TipoPropriedadeIntelectual.find((el) => el.value == v);
  },
  getTiposPropriedadeIntelectual() {
    return TipoPropriedadeIntelectual;
  },

  getPGServicoTerceiro() {
    return PGServicoTerceiro;
  },

  getPGMaterialConsumo() {
    return PGMaterialConsumo;
  },

  getPGViagemDiaria() {
    return PGViagemDiaria;
  },

  getPGOutros() {
    return PGOutros;
  },

  getPGCitenel() {
    return PGCitenel;
  },

  getPGAuditoria() {
    return PGAuditoria;
  },

  TipoReceita,
  TipoDeducoes,

  getRubricas() {
    return Rubricas;
  },
  StatusPropostaProjeto,
  TipoEmpresa,
  Classificacao,
  Segmento,
  UF,
  FaseInovacao,
  TRL,
  Titulacao,
  Nacionalidade,
  TipoProduto,
  TipoAlerta,
  Periodicidade,
  Rubricas,

  getEnum(v) {
    let Enum = [
      ...TipoServico,
      ...TipoMaterial,
      ...TipoMaterialPE,
      ...TipoViagem,
      ...TipoRecurso,
      ...Alfabeto,
      ...Funcao,
      ...Segmento,
      ...TipoEntregaveis,
      ...SubTipoEntregaveis,
      ...SubTipoCronogramaFinanceiro,
      ...StatusEtapa,

      ...RegraProjeto,
      ...TipoCompartilhamentoResultados,

      ...OrigemDespesa,
      ...TipoDocumentoProjeto,

      ...TipoImpactoEconomico,
      ...TipoProducaoCientifica,
      ...TipoCapacitacaoProfissional,
      ...TipoImpactoSocioambiental,
      ...TipoApoioInfraEstrutura,
      ...TipoPropriedadeIntelectual,
      ...StatusPropostaProjeto,
      ...PGCitenel,
      ...PGServicoTerceiro,
      ...PGMaterialConsumo,
      ...PGViagemDiaria,
      ...PGOutros,
      ...PGAuditoria,
      ...TipoReceita,
      ...TipoDeducoes,
      ...Rubricas,
      ...StatusProjetoGestao,
      ...TipoEmpresa,
      ...Classificacao,
      ...Titulacao,
      ...Nacionalidade,

      ...OutrosEnum,
      ...FaseInovacao,
      ...TRL,
      ...TipoProduto,
      ...Permissoes,

      ...TipoAlerta,

      ...Periodicidade,
      ...ContratoLicenca
    ];
    if (v == -1) return { value: -1, text: "Total" };
    return Enum.find((el) => el.value == v);
  },
};
